<div fxLayout="column" class="obsolete__popup">
  <div fxFlex="100" fxLayoutAlign="end center">
    <button class="obsolete-button" mat-raised-button color="primary" (click)="CloseDialog()">
      <mat-icon>clear</mat-icon>
    </button>
  </div>
  <div fxLayoutAlign="center center">
    <h3>Obsolete Browser</h3>
  </div>
  <div fxLayoutAlign="center center" class="content">
    Your browser version is out of date. Please upgrade to a modern browser to fully benefit from Labport features.
  </div>
</div>